import { defineComponent as _defineComponent } from 'vue'
import BaseButton from "@/components-UI/BaseButton.vue";
import BackArrow from "@/assets/icons/short-back-arrow.svg";
import store from "@/store";
import { useRouter } from "vue-router/composables";
import { computed, useSlots } from "vue";

interface Props {
    title?: string;
    backRoute?: string;
    nudgeTop?: number;
    titleWidth?: string;
    maxTitleWidth?: number;
    hideBackButton?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PageLayout',
  props: {
    title: null,
    backRoute: null,
    nudgeTop: null,
    titleWidth: null,
    maxTitleWidth: null,
    hideBackButton: { type: Boolean }
  },
  emits: ['back', 'click-title'],
  setup(__props: any, { emit }) {

const props = __props as {
    title?: string;
    backRoute?: string;
    nudgeTop?: number;
    titleWidth?: string;
    maxTitleWidth?: number;
    hideBackButton?: boolean;
}


const router = useRouter();

const slots = useSlots();

const goBack = () => {
    if (props.backRoute) {
        getBackAction();
    } else {
        emit('back');
    }
};

const getBackAction = () => {
    const lastRoute = store.state.beforeLastRoute;
    if (lastRoute === '/' || window.history.length <= 1) {
        router.push({ path: props.backRoute });
    } else {
        router.back();
    }
};

const getStyle = computed(() => {
    const nudgeTop = `margin-top: -${props.nudgeTop}px;`;
    return `${nudgeTop}`;
});

return { __sfc: true,props, router, emit, slots, goBack, getBackAction, getStyle, BaseButton, BackArrow }
}

})